import React, { useEffect, useState } from "react";
import { GetRequest } from "../../utils/repository/RequestMaker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRocket, faCheck, faClose } from "@fortawesome/free-solid-svg-icons";
import Header from "../../utils/components/Header/Header";
import PlanCard from "./PlanCard";
import "./Subscription.css";

function SubscriptionPlans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = () => {
    setLoading(true);
    GetRequest("/plans")
      .then((response) => {
        setPlans(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch plans", error);
        setLoading(false);
      });
  };

  const clientId = process.env.REACT_APP_MODELS_PAYPAL_CLIENT_ID;

  const displayPlans = (plans) => {
    const basicPlan = plans.filter((plan) => plan.name === "Basic Plan");
    const standardPlan = plans.filter((plan) => plan.name === "Standard Plan");
    const premiumPlan = plans.filter((plan) => plan.name === "Premium Plan");

    return (
      <>
        <Header />
        <div className="container-fluid mt-5">
          <div className="row">
            <div className="col-md-3"></div>
            <PlanCard
              planId={basicPlan[0]?.product_id}
              plan={basicPlan}
              price={basicPlan[0]?.price}
              period="Month"
              clientId={clientId}
            />
            <PlanCard
              planId={standardPlan[0]?.product_id}
              plan={standardPlan}
              price={standardPlan[0]?.price}
              period="Month"
              clientId={clientId}
            />
            <PlanCard
              planId={premiumPlan[0]?.product_id}
              plan={premiumPlan}
              price={premiumPlan[0]?.price}
              period="Month"
              clientId={clientId}
            />
            <div className="col-md-3">
              <div className="card css-card">
                <div className="description">
                  <h6>Inscpection Report</h6>
                  <hr className="divider" />
                  <h6>Save Draft Feature</h6>
                  <hr className="divider" />
                  <h6>Private Data Display</h6>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card css-card">
                <div className="description">
                  <h6>5</h6>
                  <hr className="divider" />
                  <h6>
                    <FontAwesomeIcon
                      className="icon-css-small"
                      icon={faClose}
                    />
                  </h6>
                  <hr className="divider" />
                  <h6>
                    <FontAwesomeIcon
                      className="icon-css-small"
                      icon={faClose}
                    />
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card css-card">
                <div className="description">
                  <h6>20</h6>
                  <hr className="divider" />
                  <h6>
                    <FontAwesomeIcon
                      className="icon-css-small"
                      icon={faCheck}
                    />
                  </h6>
                  <hr className="divider" />
                  <h6>
                    <FontAwesomeIcon
                      className="icon-css-small"
                      icon={faClose}
                    />
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card css-card">
                <div className="description">
                  <h6>60</h6>
                  <hr className="divider" />
                  <h6>
                    <FontAwesomeIcon
                      className="icon-css-small"
                      icon={faCheck}
                    />
                  </h6>
                  <hr className="divider" />
                  <h6>
                    <FontAwesomeIcon
                      className="icon-css-small"
                      icon={faCheck}
                    />
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return loading ? <div>Loading...</div> : <div>{displayPlans(plans)}</div>;
}

export default SubscriptionPlans;
